module.exports = {
  BACKGROUND_TRANSPARENCY: {
    large: '0.04',
    small: '0.05',
  },
};
